import RandExp from 'randexp'

export const truncateAddress = (address: string) => {
  if (!address) return 'No Account'
  const match = address.match(/^(0x[a-zA-Z0-9]{2})[a-zA-Z0-9]+([a-zA-Z0-9]{2})$/)
  if (!match) return address
  return `${match[1]}…${match[2]}`
}

export const toHex = (num: number) => {
  const val = Number(num)
  return '0x' + val.toString(16)
}

export const generateEAPCallSign = (eapId: number, wordsList: string[]) => {
  // NOTE: added since SS7 release, Oct 20 2023. 3 words callsign before then. If further update, search and replace 11852352, which is 228^3 permutations
  const fourthIter = eapId % 228
  const thirdIter = Math.floor(eapId / 228) % 228
  const secondIter = Math.floor(eapId / (228 * 228)) | 0
  return `Claw ${wordsList[secondIter]} ${wordsList[thirdIter]} ${wordsList[fourthIter]}`
}

export const generateTowerKeyFreeCode = () => {
  return new RandExp(/[a-zA-Z0-9]{9}/).gen()
}

export const parseProductName = (productName: string) => {
  const chunks = productName.split('~')
  const category = chunks.slice(1).join(' ')
  const words = chunks[0]?.split(' ') ?? []
  const name = words.slice(1).join(' ') // Get all words from the second one onwards. Then join them back into a single string
  return { rarity: words[0] as 'Common' | 'Rare' | 'Epic' | 'Exotic' | 'Legendary' | 'Relic' | '', name, category }
}
